import React from 'react';
import mapValues from 'lodash/mapValues';
import moment from 'moment';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import LangTabs from '../layout/LangTabs.jsx';

import env from '~/commons/config/env';

const defaults = {
  active: false,
  startAt: {
    date: moment().format('YYYY-MM-DD'),
    time: '00:00',
  },
  endAt: {
    date: '',
    time: '',
  },

  title: mapValues(env.langs, () => ''),
  content: mapValues(env.langs, () => ''),
  coverImg: mapValues(env.langs, () => ''),
};

const FormNews = ({
  news,
}) => (
  <FormResource
    {...{
      defaults,
      stored: news ? {
        ...news,
        startAt: {
          date: moment(news.startAt).format('YYYY-MM-DD'),
          time: moment(news.startAt).format('HH:mm'),
        },
        endAt: {
          date: moment(news.endAt).format('YYYY-MM-DD'),
          time: moment(news.endAt).format('HH:mm'),
        },
      } : undefined,
      api: '/api/site/news',
      onSubmit: (v) => ({
        ...v,
        startAt: moment(
          `${v.startAt.date} ${v.startAt.time}`,
          'YYYY-MM-DD HH:mm',
        ).toDate(),
        endAt: moment(
          `${v.endAt.date} ${v.endAt.time}`,
          'YYYY-MM-DD HH:mm',
        ).toDate(),
      }),
    }}
  >
    <div className="row">
      <div className="col-auto">
        <div className="form-group">
          <label>Active</label>
          <FormCheckGroup
            name="active"
            type="checkbox"
            label=""
            asSwitch
          />
        </div>
      </div>
      <div className="col">
        <div className="form-row">
          <div className="col">
            <FormGroup
              name="startAt.date"
              type="date"
              label="Start Date"
            />
          </div>
          <div className="col">
            <FormGroup name="startAt.time" type="time" label="Time" />
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <FormGroup
              name="endAt.date"
              type="date"
              label="End Date"
            />
          </div>
          <div className="col">
            <FormGroup name="endAt.time" type="time" label="Time" />
          </div>
        </div>
      </div>
    </div>

    <LangTabs>
      {({ lang }) => (
        <div className="pt-3">
          <FormGroup name={`title.${lang}`} label="Title" />
          <FormGroup
            name={`coverImg.${lang}`}
            as="coverImg"
            label="Cover Image"
            api="/api/site/news/files"
          />
          <FormGroup
            name={`content.${lang}`}
            label="Content"
            as="summernote"
            fileUploadUrl="/api/site/news/files"
          />
        </div>
      )}
    </LangTabs>
  </FormResource>
);

export default FormNews;
